var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "layout__main" }, [
      _c(
        "div",
        { staticClass: "layout__main-form" },
        [
          _c("ComisionUtilidad", {
            attrs: {
              comisionesUtilidades: _vm.form.comisiones_utilidades,
              erroresComisionesUtilidades: _vm.errores.comisiones_utilidades
            }
          }),
          _vm._v(" "),
          _c("ComisionVenta", {
            attrs: {
              comisionesVentas: _vm.form.comisiones_ventas,
              erroresComisionesVentas: _vm.errores.comisiones_ventas,
              optionsCategorias: _vm.options_categorias
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main-buttons" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.botonGuardar()
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _c("span", [_vm._v("Guardar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-light btn--text",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.botonLimpiar()
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _c("span", [_vm._v("Nuevo")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-danger",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.botonCerrar()
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-times" }),
                _c("span", [_vm._v("Cerrar")])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Comisiones")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93d0dfe2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93d0dfe2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/parametrizacion/comisiones/Comisiones.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-93d0dfe2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/parametrizacion/comisiones/Comisiones.vue
// module chunks = 0